// extracted by mini-css-extract-plugin
module.exports = {"container":"main_container_3EUVG","test":"main_test_2a24W"};